import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
  selector: 'app-horizontal-selector',
  standalone: true,
  imports: [CommonModule, InlineSVGModule],
  templateUrl: './horizontal-selector.component.html',
  styleUrl: './horizontal-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalSelectorComponent {
  @ContentChild(TemplateRef) templateRef?: TemplateRef<unknown>;

  @Input() data: string[] = [];
  @Input() placeholder? = '';

  @Output() setExpanded = new EventEmitter<boolean>();

  @Input() index = 0;
  @Output() indexChange = new EventEmitter<number>();
  @Output() selectedChange = new EventEmitter<string>();

  public updateIndex(param: number): void {
    const maxIndex = this.data.length - 1;

    if (param > 0) {
      this.index = this.index < maxIndex ? this.index + param : 0;
    } else {
      this.index = this.index > 0 ? this.index + param : maxIndex;
    }
    this.indexChange.emit(this.index);
    this.selectedChange.emit(this.data[this.index]);

    if (this.placeholder) {
      this.setExpanded.emit(this.placeholder != this.data[this.index]);
    }
  }
}
